import {IBuilderComponentGroup, IWidgetBuilderComponent, IWidgetBuilderComponentMeta, widgetBuilderComponentMetaTypes} from "./types";
import {contentTypes} from "./event";

export const componentEventType = {
  content_odds_preview: contentTypes.oddsAndPreview,
  content_betting_tips: contentTypes.bettingTips,
  content_form: contentTypes.form,
  content_faq: contentTypes.faq
}

// Builder components storage
const builderComponentGroupsStorage: IBuilderComponentGroup[] = [];

export const setUpBuilderComponentGroups = (builderComponentGroups: IBuilderComponentGroup[]) => {
  builderComponentGroupsStorage.push(...builderComponentGroups);
}

export const getWidgetBuilderComponentMetaByType = (type: widgetBuilderComponentMetaTypes): string | null => {
  const widgetBuilderComponentMeta = getBuilderComponentMetas().find((getBuilderComponentMeta: IWidgetBuilderComponentMeta) => getBuilderComponentMeta.type === type)
  return widgetBuilderComponentMeta ? widgetBuilderComponentMeta.value : null;
}

const getBuilderComponentMetas = (): IWidgetBuilderComponentMeta[] => {
  const builderComponentMetas: IWidgetBuilderComponentMeta[] = []
  builderComponentGroupsStorage.forEach((builderComponentGroup: IBuilderComponentGroup) => {
    builderComponentGroup.widgetBuilderComponent.forEach((widgetBuilderComponent: IWidgetBuilderComponent) => {
      if (widgetBuilderComponent.widgetBuilderComponentMetas) {
        builderComponentMetas.push(...widgetBuilderComponent.widgetBuilderComponentMetas);
      }
    })
  })

  return builderComponentMetas;
}
